'use client';

import { PropsWithChildren, useState } from 'react';

import { PropsContextProvider } from '@/context/Feedback';
import { FeedbackProps } from '@/types/feedback';

import { ChooseScore } from './ChooseScore';
import s from './styles.module.scss';
import { Score } from './types';

export function Feedback({
  children,
  onSubmitForm,
  isLoadingSendFeedback,
  onChooseScore,
  isOpenThanksBlock,
  setIsOpenThanksBlock,
  isOpenFeedbackForm,
  setIsOpenFeedbackForm,
}: PropsWithChildren<FeedbackProps>) {
  const [selectedScore, setSelectedScore] = useState<null | Score>(null);
  return (
    <PropsContextProvider
      isOpenFeedbackForm={isOpenFeedbackForm}
      setIsOpenFeedbackForm={setIsOpenFeedbackForm}
      isOpenThanksBlock={isOpenThanksBlock}
      setIsOpenThanksBlock={setIsOpenThanksBlock}
      onChooseScore={onChooseScore}
      onSubmitForm={onSubmitForm}
      isLoadingSendFeedback={isLoadingSendFeedback}
    >
      <div className={s.feedback_container}>
        {children}
        <ChooseScore score={selectedScore} setScore={setSelectedScore} />
      </div>
    </PropsContextProvider>
  );
}
